import { jsx } from "react/jsx-runtime";
import { Autocomplete, TextField } from "@mui/material";
function Select(props) {
  const { options, label, value, setField, autocompleteProps } = props;
  return /* @__PURE__ */ jsx(
    Autocomplete,
    {
      fullWidth: true,
      size: "small",
      ...autocompleteProps,
      "data-testid": "TidalControlsSelect",
      onChange: (_, value2) => {
        if (!value2) return;
        setField(label, value2);
      },
      options,
      renderInput: (params) => /* @__PURE__ */ jsx(TextField, { ...params }),
      value
    }
  );
}
export {
  Select
};
//# sourceMappingURL=Select.js.map
